import SvgIcon from '@png/npm-svg-icon';
import jsonToView from '../api/json-to-view';
import sortByDistance from '../utils/locations/sortByDistance';
import StockLocationFavorites from './StockLocationFavorites';
import StockLocationAddToCart from './StoreLocationAddToCart';

class StockLocationSearch {
  constructor() {
    this.config = {
      moduleList: () => document.querySelectorAll('[data-module="StockLocationSearch"]'),
      stockButton: () => document.querySelectorAll('[data-module="StockIcon"]'),
      input: el => el.querySelector('[data-module="Search"]'),
      results: el => el.querySelector('[data-module="Results"]')
    };
  }

  static initializeSearchBox(module, input, locationsJson, stockBranches, results) {
    const defaultBounds = new google.maps.LatLngBounds(
      new google.maps.LatLng(50.75, 3.35), // South-west corner of the country
      new google.maps.LatLng(53.55, 7.22) // North-east corner of the country
    );

    // Create the search box with the specified bounds
    const searchBox = new google.maps.places.SearchBox(input);
    searchBox.setBounds(defaultBounds);
    const { productId, itemcode, description, orderUnit } = module.dataset;

    searchBox.addListener('places_changed', async () => {
      results.classList.add('is-loading');
      const place = searchBox.getPlaces()[0];

      if (!place.geometry) {
        results.classList.remove('is-loading');
        results.innerHTML = 'Ongeldig adres';
        return;
      }
      input.value = place.formatted_address;
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();
      const locationsSorted = sortByDistance(locationsJson, lat, lng);
      const limitedList = locationsSorted.slice(0, 10);

      const newHtml = await jsonToView(
        {
          locations: limitedList,
          stockBranches,
          productId,
          itemcode,
          productDescription: description,
          orderUnit
        },
        'FoundLocations'
      );
      results.classList.remove('is-loading');
      results.innerHTML = newHtml;
      new SvgIcon().init();
      new StockLocationFavorites().init();
      new StockLocationAddToCart().init();
    });
  }

  static parseLocation(location) {
    let { Latitude, Longitude } = location;

    if (!Latitude) {
      Latitude = '0';
    }

    if (!Longitude) {
      Longitude = '0';
    }

    return {
      ...location,
      Latitude: Number(Latitude.replace(',', '.')),
      Longitude: Number(Longitude.replace(',', '.'))
    };
  }

  init() {
    const { moduleList, stockButton } = this.config;

    moduleList().forEach(module => {
      const { initialized, locations, stockBranches } = module.dataset;

      if (initialized) return;

      module.dataset.initialized = true;

      const input = this.config.input(module);
      const results = this.config.results(module);

      const locationsJson = JSON.parse(locations).map(StockLocationSearch.parseLocation);
      StockLocationSearch.initializeSearchBox(module, input, locationsJson, stockBranches, results);
    });

    stockButton().forEach(button => {
      const { initialized } = button.dataset;

      if (initialized) return;

      button.dataset.initialized = true;

      const input = this.config.input(button.parentElement);

      button.addEventListener('click', () => {
        // delay of 200ms to wait for the google maps api to load

        setTimeout(() => {
          input.focus();
          google.maps.event.trigger(input, 'keydown', {
            keyCode: 13
          });
          input.blur();
        }, 200);
      });
    });
  }
}

export default StockLocationSearch;
